import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import type { AUTH_TYPES } from '@/types';

interface AuthTypeFieldProps {
  value: AUTH_TYPES | null;
  setValue: (value: AUTH_TYPES | null) => void;
}

function AuthTypeField({ value, setValue }: AuthTypeFieldProps): React.JSX.Element {
  return (
    <FormControl fullWidth>
      <InputLabel id='auth-type-label'>Auth Type</InputLabel>
      <Select
        labelId='auth-type-label'
        label='Auth Type'
        value={value ?? ''}
        onChange={(e) => {
          const v = e.target.value;
          setValue(v ? (v as AUTH_TYPES) : null);
        }}
      >
        <MenuItem value=''>
          <em>None</em>
        </MenuItem>
        <MenuItem value='oidc'>oidc</MenuItem>
      </Select>
    </FormControl>
  );
}

export default AuthTypeField;

